// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"95319860","367":"dc2e912e","571":"66724d35"}[chunkId] + ".chunk.js";
};